'use strict';

import React from 'react';
import LazyLoadImage from 'core_modules/aexp-lazyload-image';
import { isExternal } from 'src/universal/utils/url/index';
import textRemoveTags from 'service_modules/utils/text-remove-tags';

function HtmlImage(props) {
  if (!props) {
    return null;
  }

  const attribues = Object.assign({}, props.attribues || props);
  const elementName = props.name || 'html-img';

  if (
    !isExternal(attribues.src) &&
    String(attribues.src).indexOf('data:image') !== 0
  ) {
    const ASSET_BASE_URL = '/us/credit-cards/business/site';
    attribues.src = `${ASSET_BASE_URL}${attribues.src}`;
  }

  function onClick(event) {
    props.fn && props.fn.onClick && props.fn.onClick(event);
  }

  function onLoad() {
    props.onLoad && typeof props.onLoad === 'function' && props.onLoad();
  }

  return React.createElement(
    elementName,
    {
      class: props.className
    },
    props.shouldNotLazyLoad ? (
      <img
        srcSet={attribues.srcset}
        className={attribues.className}
        sizes={attribues.sizes}
        src={attribues.src}
        data-qe-id="sideCardArt"
        alt={textRemoveTags(attribues.alt)}
        onClick={onClick}
        onLoad={onLoad}
      />
    ) : (
      <LazyLoadImage
        img={
          <img
            srcSet={attribues.srcset}
            className={attribues.className}
            sizes={attribues.sizes}
            src={attribues.src}
            data-qe-id="sideCardArt"
            alt={attribues.alt}
            onClick={onClick}
            onLoad={onLoad}
          />
        }
      />
    )
  );
}

export default HtmlImage;
